import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { GraduationCap, Award } from 'lucide-react';

const EducationSection = () => {
  const sectionRef = useScrollReveal();

  const education = [
    {
      degree: 'Doctor of Medicine (MD)',
      specialization: 'General Medicine',
      institution: 'NKP Salve Institute of Medical Sciences',
      location: 'Nagpur, Maharashtra',
      year: '2022 - 2025',
      type: 'Postgraduate'
    },
    {
      degree: 'Bachelor of Medicine, Bachelor of Surgery (MBBS)',
      specialization: '',
      institution: 'Government Medical College (GMC)',
      location: 'Nagpur, Maharashtra',
      year: '2015 - 2020',
      type: 'Undergraduate'
    }
  ];

  return (
    <section id="education" className="py-20 px-4 bg-slate-50" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          Education
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="grid md:grid-cols-2 gap-6">
          {education.map((edu) => (
            <Card 
              key={edu.degree}
              className="card-hover scroll-reveal-scale" 
              style={{ 
                borderColor: '#e8f5e9',
                animationDelay: `${0.2 + education.indexOf(edu) * 0.15}s`
              }}
            >
              <CardHeader>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center" style={{ backgroundColor: '#e8f5e9' }}>
                    {edu.type === 'Postgraduate' ? (
                      <Award style={{ color: 'var(--medical-primary)' }} size={28} />
                    ) : (
                      <GraduationCap style={{ color: 'var(--medical-primary)' }} size={28} />
                    )}
                  </div>
                  <div className="flex-1">
                    <CardTitle className="text-xl text-slate-900 mb-2">
                      {edu.degree}
                    </CardTitle>
                    {edu.specialization && (
                      <p className="font-semibold mb-2" style={{ color: 'var(--medical-accent)' }}>
                        {edu.specialization}
                      </p>
                    )}
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-slate-800 font-medium mb-1">{edu.institution}</p>
                <p className="text-slate-600 text-sm mb-2">{edu.location}</p>
                <p className="font-semibold" style={{ color: 'var(--medical-primary)' }}>{edu.year}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
